import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import socialIcons from "../Footer/FooterSocial"
import InnerHTML from 'dangerously-set-html-content'
import { scroller } from 'react-scroll'

const Subscribe = () => {

  // form widget code from Click Dynamics system
  let formCode = `<script type="text/javascript">var loc = "https://analytics-eu.clickdimensions.com/jmfinncom-a5msl/pages/";</script>
<script type="text/javascript" src="https://cdn-eu.clickdimensions.com/web/v10/CDWidget.js"></script>
<div id="subscribe-form" pageID="jl0maeuheeui0iva9f96xw"></div>`

    function testSubscribeFrom() {
        setTimeout(function(){
            // scroll to top
            if (typeof window === "undefined") {
              // SSR
            } else {
                const testFormElement = document.querySelector("#subscribe-form");
                let testForm;
                if(testFormElement !== null) {
                  testForm = testFormElement.innerHTML.trim().length
                }

                if(window.location.hash && testForm > 0) {
                    if(window.location.hash === "#scroll-subscribe") {
                        scroller.scrollTo('scroll-subscribe', {
                          duration: 600,
                          delay: 50,
                          smooth: true,
                          offset: -150, // Scrolls to element + 150 pixels down the page
                        })
                    }
                }
                else {
                    testSubscribeFrom()
                }
            }

        }, 100);
    }

    testSubscribeFrom()



  return (
    <div className="subscribe">
      <Container fluid>
        <Row className="g-0">
          <Col sm={12} lg={{span:10, offset:1}}>
            <Container fluid>
              <Row>
                <Col xs={12} md={6}>
                  <p className="hr hr--top">If you like this article, follow us for more insights.</p>
                  <ul className="social-share">
                    {socialIcons.map((item, index) => {
                      return <li key={index}><a href={item.url} target="_blank" rel="noopener noreferrer" aria-label={item.ariaLabel}>
                        {item.icon}
                      </a></li>
                    })}
                  </ul>
                </Col>
                <Col xs={12} md={6} name="scroll-subscribe">
                  <p className="hr hr--top">To receive more content like this subscribe today.</p>

                  <InnerHTML html={formCode} />

                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Subscribe
